import React, { FC } from 'react';
import { Button } from 'antd';
import { SearchInput } from 'common/components';
import { Plus } from 'common/svg';

interface IComponentProps {
  onCreate: () => void;
  onSearch: (value?: string) => Promise<void>;
}

export const CityListPageHeader: FC<IComponentProps> = ({ onCreate, onSearch }) => {
  return (
    <div className="flex align-center gap-3">
      <Button className="button-sm primary" icon={<Plus className="icon-white" />} onClick={onCreate}>
        Новый город
      </Button>

      <SearchInput placeholder="Введите название города" onSearch={onSearch} />
    </div>
  );
};
